
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrdersService } from 'src/app/services/orders/orders.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-orders',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.css'
})
export class OrdersComponent implements OnInit {
  orders: any;
  load = false;
  selectedOrder: any;

  constructor(private ordersService: OrdersService, private modalService: NgbModal) {}

  ngOnInit() {
    this.fetchOrders();
  }

  fetchOrders() {
    this.load = true;
    this.ordersService.getOrders().subscribe({
      next: (res) => {
        if (Array.isArray(res)) {
          this.orders = res.map((order: any) => ({
  ...order,
  items: Array.isArray(order.items) ? order.items : JSON.parse(order.items || '[]')
}));
        } else {
          this.orders = [];
        }
        this.load = false;
      },
      error: () => {
        this.load = false;
      }
    });
  }

  openItemsModal(order: any, content: any) {
    this.selectedOrder = order;
    this.modalService.open(content);
  }





printOrderHtml() {
  const DATA: any = document.getElementById('order-pdf');
  if (!DATA) return;

  html2canvas(DATA, { scale: 2 }).then((canvas) => {
    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');

    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    pdf.save(`შეკვეთა_${this.selectedOrder?.id}.pdf`);
  });
}

  delete(id: any) {
    if(confirm('ნამდვილათ გსურთ წაშლა')){
      this.ordersService.delete(id).subscribe(
        () => {
          this.fetchOrders();
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }



}